import { Check, Minus, Plus } from "lucide-react";
import type { ReactNode } from "react";
import type { MaterialOption } from "../types";
import { formatPrice } from "../data";

export function SectionHeading({
  children,
  aside
}: {
  children: ReactNode;
  aside?: ReactNode;
}) {
  return (
    <div className="section-heading">
      <h3>{children}</h3>
      {aside}
    </div>
  );
}

export function MaterialGrid({
  items,
  selected,
  onSelect
}: {
  items: MaterialOption[];
  selected: string;
  onSelect: (id: string) => void;
}) {
  return (
    <div className="material-grid">
      {items.map((item) => {
        const active = selected === item.id;
        return (
          <button
            key={item.id}
            type="button"
            className={`material-card ${active ? "selected" : ""}`}
            onClick={() => onSelect(item.id)}
            aria-pressed={active}
          >
            <span
              className={`material-swatch texture-${item.texture ?? "smooth"}`}
              style={{ "--swatch": item.color } as React.CSSProperties}
            >
              {active && <Check size={15} />}
            </span>
            <span className="material-name">{item.name}</span>
            <small>{item.priceDelta === 0 ? "Inkluderet" : `+ ${formatPrice(item.priceDelta)}`}</small>
          </button>
        );
      })}
    </div>
  );
}

export function Stepper({
  label,
  value,
  min,
  max,
  onChange
}: {
  label: string;
  value: number;
  min: number;
  max: number;
  onChange: (value: number) => void;
}) {
  return (
    <div className="stepper-row">
      <span>{label}</span>
      <div className="stepper">
        <button
          type="button"
          aria-label={`Færre ${label.toLowerCase()}`}
          disabled={value <= min}
          onClick={() => onChange(value - 1)}
        >
          <Minus size={15} />
        </button>
        <output>{value}</output>
        <button
          type="button"
          aria-label={`Flere ${label.toLowerCase()}`}
          disabled={value >= max}
          onClick={() => onChange(value + 1)}
        >
          <Plus size={15} />
        </button>
      </div>
    </div>
  );
}

export function ToggleRow({
  label,
  description,
  checked,
  disabled,
  onChange
}: {
  label: string;
  description?: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <label className={`toggle-row ${disabled ? "disabled" : ""}`}>
      <span>
        <strong>{label}</strong>
        {description && <small>{description}</small>}
      </span>
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="toggle-track" aria-hidden="true">
        <span />
      </span>
    </label>
  );
}
